import axios from 'axios';
import { getConfig } from './config';

export default class consentSolution {

    private url_api_save_consent: string = '';

    constructor() {
        const config = getConfig();
        if (config) {
            this.url_api_save_consent = config.rest_urls.save_consent;
        }
    }

    /**
     * Get consent data from form and send to API
     */
    getConsent(el: string): void {
        const config = getConfig();
        if (!config) return;

        const data: Record<string, any> = {};

        const form = document.querySelector(el) as HTMLFormElement | null;
        const html_form = document.querySelector(el) as HTMLDivElement | null;

        if (form != null) {
            data['type'] = this.getType(form);
            data['details'] = this.getDetails(form);

            const objects = form.querySelectorAll('[data-cons-preference]');
            data['preferences'] = this.getPreferences(objects);

            const no_obj_cons = document.querySelectorAll('.no-obj-cons');
            const content = new FormData(form);

            no_obj_cons.forEach((value) => {
                const n_input = value as HTMLInputElement;
                content.delete(n_input.name);
            });

            data['content'] = this.serialize(content);
            data['html'] = html_form?.outerHTML;
            data['current_url'] = window.location.href;
        }

        this.sendRequest(data);
    }

    protected getType(el: HTMLFormElement): string | null {
        return el.getAttribute('data-cons-type');
    }

    protected getDetails(el: HTMLFormElement): Record<string, string | null> {
        const fields = ['full_name', 'first_name', 'last_name', 'email', 'phone'] as const;
        const details: Record<string, string | null> = {};

        for (const field of fields) {
            const input = el.querySelector<HTMLInputElement>(`[data-cons-obj="${field}"]`);
            details[field] = input?.value ?? null;
        }

        return details;
    }

    protected getPreferences(objects: NodeListOf<Element>): Record<string, boolean> {
        const preferences: Record<string, boolean> = {};

        objects.forEach((value) => {
            const obj = value as HTMLInputElement | null;
            const objName = obj?.getAttribute('data-cons-preference');
            if (objName) {
                preferences[objName] = obj?.checked ?? false;
            }
        });

        return preferences;
    }

    protected sendRequest(data: Record<string, any>): void {
        const datastring = JSON.stringify(data);
        const queryString = new URLSearchParams({ 'fields': datastring }).toString();

        axios.post(this.url_api_save_consent, queryString)
            .then((response: any) => {
                // Response handled silently
            })
            .catch(() => {
                // Error handled silently
            });
    }

    protected serialize(data: FormData): Record<string, any> {
        const obj: Record<string, any> = {};

        for (const [key, value] of data) {
            if (obj[key] !== undefined) {
                if (!Array.isArray(obj[key])) {
                    obj[key] = [obj[key]];
                }
                obj[key].push(value);
            } else {
                obj[key] = value;
            }
        }

        return obj;
    }
}
